<script lang="ts">
    import { onMount } from 'svelte';
    import { api } from '../lib/api';
    import type { AuditLog } from '../lib/types';
    import { formatDate } from '../lib/format';

    let items = $state<AuditLog[]>([]);
    let cursor = $state<string | null>(null);
    let loading = $state(false);
    let filterAction = $state('');
    let filterActor = $state('');

    async function load(reset = true) {
        loading = true;
        try {
            const params = new URLSearchParams({ limit: '100' });
            if (!reset && cursor) params.set('cursor', cursor);
            if (filterAction) params.set('action', filterAction);
            if (filterActor) params.set('actorType', filterActor);

            const res = await api<{ items: AuditLog[]; nextCursor: string | null }>(`/api/audit?${params}`);
            items = reset ? res.items : [...items, ...res.items];
            cursor = res.nextCursor;
        } finally { loading = false; }
    }

    onMount(() => load(true));
</script>

<div class="page-header">
    <h1>Audit Log</h1>
    <div class="toolbar">
        <select bind:value={filterActor} onchange={() => load(true)}>
            <option value="">All actors</option>
            <option value="admin">Admin</option>
            <option value="consumer">Consumer</option>
            <option value="system">System</option>
        </select>
        <input placeholder="Filter action (e.g. SECRET_UPDATE)" bind:value={filterAction} onkeydown={(e) => e.key === 'Enter' && load(true)} />
        <button onclick={() => load(true)}>Apply</button>
    </div>
</div>

<div class="card">
    <table>
        <thead>
        <tr><th>Time</th><th>Actor</th><th>Action</th><th>Target</th><th>IP</th></tr>
        </thead>
        <tbody>
        {#each items as log}
            <tr>
                <td class="small">{formatDate(log.timestamp)}</td>
                <td>
            <span class="badge {log.actorType === 'admin' ? 'info' : log.actorType === 'consumer' ? 'success' : 'warning'}">
              {log.actorType}
            </span>
                    <span>{log.actorLabel}</span>
                </td>
                <td class="mono small">{log.action}</td>
                <td class="mono small">{log.target ?? '—'}</td>
                <td class="dim small">{log.ipAddress ?? '—'}</td>
            </tr>
        {:else}
            <tr><td colspan="5" class="muted" style="text-align:center;padding:20px;">No entries.</td></tr>
        {/each}
        </tbody>
    </table>
</div>

{#if cursor}
    <div style="text-align:center;margin-top:16px;">
        <button onclick={() => load(false)} disabled={loading}>Load more</button>
    </div>
{/if}

<style>
    .page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; gap: 12px; flex-wrap: wrap; }
    table { width: 100%; border-collapse: collapse; }
    th, td { padding: 8px 12px; text-align: left; border-bottom: 1px solid var(--border); font-size: 13px; }
    th { font-size: 11px; text-transform: uppercase; color: var(--text-2); }
    .small { font-size: 12px; }
</style>